/**
 * Validates a given NIF number.
 *
 * @param {string} nif - The NIF number to validate.
 * @return {boolean} True if the NIF number is valid, false otherwise.
 */
export const nifValidate = (nif: string) => {
  if (!/^[123]|45|5/.test(nif)) return false;

  // Calculate the total of all digits.
  let tot =
    +String(nif)[0] * 9 +
    +String(nif)[1] * 8 +
    +String(nif)[2] * 7 +
    +String(nif)[3] * 6 +
    +String(nif)[4] * 5 +
    +String(nif)[5] * 4 +
    +String(nif)[6] * 3 +
    +String(nif)[7] * 2;

  // Calculate the division and modulo of the total.
  let div = tot / 11;
  let mod = tot - parseInt(String(div)) * 11;

  // Calculate the test value.
  let tst = mod === 1 || mod === 0 ? 0 : 11 - mod;

  // Return true if the test value matches the last digit of the NIF number, false otherwise.
  return parseInt(String(nif)[8]) === tst;
};
